import { useContext, useEffect, useState } from "react";
import { CartContext } from "../../contexts/CartContext";
import { ProductsContext } from "../../contexts/ProductsContext";
import { AccountContext } from "../../contexts/AccountContext";

import LoadingBars from "../../assets/Loading/loading-bars.svg";
import "./VinculateStudent.styles.scss";
import "../ModalVinculo/ModalVinculo/ModalVinculo.styles.scss";
import CardVinculo from "../CardVinculo/CardVinculo";
import NewVinculation from "./NewVinculation/NewVinculation";

const formatCPF = (cpf = "") =>
  cpf.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

const formatPhone = (phone = "") =>
  phone.replace(/\D/g, "").replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");

const formatBirthDate = (birthDate = "") =>
  birthDate ? birthDate.slice(0, 10).split("-").reverse().join("/") : "";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 30000,
};

const VinculateStudent = ({ nextStep }) => {
  const { alreadyStudent } = useContext(CartContext);
  const {
    studentList,
    removeStudentFromUser,
    handleChangeAddStudent,
    handleSubmitAddStudent,
    isLoading,
    loggedUserData,
    autoLinkStudentsByCpf,
  } = useContext(AccountContext);
  const { selectedSubproduct, selectedProduct } = useContext(ProductsContext);

  useEffect(() => {
    if (loggedUserData) {
      autoLinkStudentsByCpf(loggedUserData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [vinculateForm, setVinculateForm] = useState(false);
  const [contaModalOpen, setContaModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);

  const anyModalOpen = contaModalOpen || addModalOpen;

  useEffect(() => {
    if (!anyModalOpen) return;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [anyModalOpen]);

  const closeAddModal = () => {
    setAddModalOpen(false);
    setVinculateForm(false);
  };

  return (
    <div className="mt-5 flex flex-col justify-center">
      <div className="d-flex justify-center w-full">
        {!!selectedProduct && (
          <>
            <div className="compra-title-section-container" style={{'--before-color': 'var(--yellow-base)'}}>
              <h1 className="title-section font-semibold text-lg sm:text-xl">
                Selecione um destinatário para a compra
              </h1>
              <hr />
            </div>
            <div className="student-card-list">
              <div className="card-vinculo-container">
                <div
                  className="card-vinculo-content-left"
                  onClick={() => alreadyStudent(selectedSubproduct, nextStep)}
                >
                  <div className="card-vinculo-nome">Para mim</div>
                  <p className="text-grey-brand text-xs sm:text-sm mt-2">
                    Selecione se quiser comprar o produto para essa conta mesmo, sem vincular nenhum aluno ou dependente
                  </p>
                </div>
                <div className="card-vinculo-content-right card-vinculo-content-right--center">
                  <button onClick={() => setContaModalOpen(true)}>
                    <span className="edit-btn material-symbols-outlined">help</span>
                  </button>
                </div>
              </div>
              {contaModalOpen && (
                <div onClick={() => setContaModalOpen(false)} style={overlayStyle}>
                  <div
                    className="vinculo-modal-wrapper"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="vinculo-modal-container">
                      <button
                        className="close-btn"
                        onClick={() => setContaModalOpen(false)}
                      >
                        <span className="material-symbols-outlined">close</span>
                      </button>
                      <div className="vinculo-modal-content">
                        <h2>Dados da Conta</h2>
                        <h3>Nome: <span>{loggedUserData?.customer?.name}</span></h3>
                        <h3>CPF: <span>{formatCPF(loggedUserData?.customer?.cpf)}</span></h3>
                        <h3>Telefone: <span>{formatPhone(loggedUserData?.customer?.cellPhone)}</span></h3>
                        <h3>Data de Nascimento: <span>{formatBirthDate(loggedUserData?.customer?.birthDate)}</span></h3>
                        <h2>Endereço</h2>
                        <h3>CEP: <span>{loggedUserData?.customer?.zipcode}</span></h3>
                        <h3>Rua: <span>{loggedUserData?.customer?.street}, {loggedUserData?.customer?.houseNumber}</span></h3>
                        <h3>Bairro: <span>{loggedUserData?.customer?.neighborhood}</span></h3>
                        <h3>Cidade: <span>{loggedUserData?.customer?.city} - {loggedUserData?.customer?.state}</span></h3>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {studentList?.length ? (
                studentList.map((student) => (
                  <CardVinculo
                    key={student.id}
                    Student={student}
                    Product={selectedSubproduct}
                    onClickVinculate={true}
                    vinculateCallback={nextStep}
                    removeStudentFromUser={() =>
                      removeStudentFromUser(student.student.id)
                    }
                  />
                ))
              ) : (
                <h1 className="my-8 text-center w-full text-lg font-semibold text-grey-dark">
                  Nenhum aluno vinculado no momento
                </h1>
              )}
            </div>

            <div className="w-full mt-4">
              <div
                className="card-adicionar-aluno"
                onClick={() => setAddModalOpen(true)}
              >
                <span className="material-symbols-outlined">add_circle</span>
                <div>
                  <h1>Adicionar Aluno</h1>
                  <p>Adicione um aluno por RA ou cadastre um aluno sem RA</p>
                </div>
              </div>
            </div>

            {addModalOpen && (
              <div onClick={closeAddModal} style={overlayStyle}>
                <div
                  className="modal-adicionar-aluno"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button className="modal-adicionar-close" onClick={closeAddModal}>
                    <span className="material-symbols-outlined">close</span>
                  </button>
                  <div>
                    {vinculateForm ? (
                        <NewVinculation
                          handleOpenList={closeAddModal}
                          onBack={() => setVinculateForm(false)}
                        />
                      ) : (
                        <div className="search-box flex flex-col gap-4 items-center w-full">
                          <h1 className="text-center my-4 text-2xl font-semibold text-grey-dark">
                            Adicionar Aluno por RA
                          </h1>
                          <form
                            className="search-form w-full md:w-[80%]"
                            onSubmit={(e) => handleSubmitAddStudent(e, closeAddModal)}
                          >
                            <div className="relative">
                              <div className="search-icon">
                                <span className="material-symbols-outlined">
                                  person_search
                                </span>
                              </div>
                              <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                id="search-ra"
                                className="search-field !pl-10"
                                placeholder="Digite o RA do Aluno"
                                required
                                onChange={(event) => {
                                  const digitsOnly = event.target.value.replace(/\D/g, "");
                                  event.target.value = digitsOnly;
                                  handleChangeAddStudent(digitsOnly);
                                }}
                              />
                              <button
                                disabled={isLoading === true ? true : false}
                                type="submit"
                                className={
                                  isLoading === true
                                    ? `btn-pesquisar-loading`
                                    : `btn-adicionar`
                                }
                              >
                                {isLoading === true ? (
                                  <img src={LoadingBars} alt="" />
                                ) : (
                                  "Adicionar"
                                )}
                              </button>
                            </div>
                          </form>
                          <h5 className="text-grey-dark text-center font-semibold">
                            ou
                          </h5>
                          <button
                            className="border shadow-md p-3 rounded-xl w-fit hover:bg-slate-100"
                            onClick={() => setVinculateForm(true)}
                          >
                            <div className="flex items-center gap-2">
                              <span className="material-symbols-outlined text-green-base text-5xl">
                                add_circle
                              </span>
                              <div className="flex flex-col items-start">
                                <h3 className="text-green-base text-center font-semibold">
                                  Adicionar aluno sem RA
                                </h3>
                                <h5 className="text-grey-brand text-sm text-center font-medium">
                                  Alunos ainda não matriculados na escola
                                </h5>
                              </div>
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default VinculateStudent;
